import { useEffect, useState } from 'react';
import { PIZAS_STORE_TZ } from '../lib/dateMexico';

function formatLiveClock(ms) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: PIZAS_STORE_TZ,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(ms));
  const get = (t) => parts.find((p) => p.type === t)?.value || '00';
  return `${get('hour')}:${get('minute')}:${get('second')}`;
}

export default function LiveClock({ className = '', compact = false }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const tick = () => setNow(Date.now());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  const timeClass = compact
    ? 'text-xl sm:text-2xl font-bold font-mono tabular-nums tracking-wide text-foreground leading-none'
    : 'text-5xl sm:text-6xl font-bold font-mono tabular-nums tracking-wide text-foreground leading-none';

  return (
    <div className={`select-none text-right shrink-0 ${className}`.trim()}>
      <p
        className={timeClass}
        aria-live="polite"
        aria-label={`Hora actual ${formatLiveClock(now)}`}
      >
        {formatLiveClock(now)}
      </p>
      <p className={`text-muted-foreground capitalize ${compact ? 'text-[11px] mt-0.5' : 'text-sm mt-2'}`}>
        {new Date(now).toLocaleDateString('es-MX', {
          timeZone: PIZAS_STORE_TZ,
          weekday: compact ? 'short' : 'long',
          day: 'numeric',
          month: compact ? 'short' : 'long',
          year: 'numeric',
        })}
      </p>
    </div>
  );
}
